import { RESET_STATE } from 'store/global/actions';
import { LOAN_APPLICATION_TAGS_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = null;

const loanApplicationTagsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_APPLICATION_TAGS_ACTION_TYPE.GET_TAGS: {
      return payload || initialState;
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanApplicationTagsReducer;
